import { httpClient } from '@/services/http/httpClient'

type RemoveUsersParams = {
  userIds: string[]
  ideaId: string
  message: string
}

export async function removeUsers({
  ideaId,
  message,
  userIds,
}: RemoveUsersParams): Promise<void> {
  await httpClient.post('/ideas/idea-users/invite-users-to-idea', {
    receiverIds: userIds,
    ideaId,
    message,
    action: 'EXCLUDE',
  })
}
